import { Component, OnInit } from '@angular/core';
import { CadastroService } from 'src/app/services/cadastro.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AdesaoService } from 'src/app/services/adesao.service';
import { UtilService } from 'src/app/services/util.service';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import * as RecaptchaModule from 'src/app/services/recaptchaV3.service.js';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
declare var $: any;

@Component({
    selector: 'app-beneficiario',
    templateUrl: './beneficiario.component.html',
    styleUrls: ['./beneficiario.component.css'],
    imports: [NgxCaptchaModule, CommonModule, FormsModule, ReactiveFormsModule, NgxMaskDirective]
})
export class BeneficiarioComponent implements OnInit {

  private recaptchaService = new RecaptchaModule.RecaptchaV3Service();

  parentescos: any[] = [];

  beneficiarios: any[] = [];
  form: FormGroup = null;

  benefSelecionado: any = null;

  assinatura: string = "";

  loadingInserir: boolean = false;
  loadingRemover: boolean = false;

  percentualTotal: number = 0;
  percentualFaltante: number = 0;
  msgErroPercentual: string = null;

  constructor(private cadastro: CadastroService, private adesao: AdesaoService, private util: UtilService, private toastr: ToastrService) {

    this.form = new FormGroup({
      CPFBenef: new FormControl(null),
      nomeBenef: new FormControl(null,[Validators.required]),
      dtaNascBenef: new FormControl(null,[Validators.required]),
      emailBenef: new FormControl(null,[Validators.required, Validators.email]),
      celularCompletoBenef: new FormControl(null, [Validators.minLength(10)]),
      celularBenef: new FormControl(null),
      DDDCelularBenef: new FormControl(null),
      prcBenef: new FormControl(null,[Validators.required, Validators.min(1), Validators.max(100)]),
      codParentesco: new FormControl(null, [Validators.required]),
      assinatura: new FormControl(null, [Validators.required]),
      recaptchaV2Token: new FormControl(null, [Validators.required]),
      recaptchaV3Token: new FormControl(null, [Validators.required])
    });

   }

  ngOnInit() {
    this.listarParentesco();


    this.recaptchaService.genToken('BeneficiarioComponent')
        .then(token => {
            this.form.patchValue({ recaptchaV3Token: token });
        })
        .catch(err => console.error("Erro no reCAPTCHA", err));

    $('#benefeciarioModal').on('hidden.bs.modal', ()=>{
      this.form.reset();
    });
  }

  listar(){

    this.percentualTotal = 0;

    this.cadastro
    .listarBeneficiario()
    .subscribe(
      (res:any)=>{
        this.beneficiarios = res;

        res.forEach(item => {
          this.percentualTotal+= Number(item.PRC_BENEF);
        });

        this.percentualFaltante = 100-this.percentualTotal;

      }
    )
  }

  validarPercentual(v){
    if (v <= 0) {
      this.msgErroPercentual = "O valor deve ser maior que 0%";
    }
    if(v == '' ||  v > this.percentualFaltante){
      this.msgErroPercentual = "O valor deve ser menor ou igual a: " + this.percentualFaltante + "%";
    }else{
      this.msgErroPercentual = null;
    }
  }

  async inserir(): Promise<boolean> {

    await this.recaptchaService.genToken('BeneficiarioComponent')
    .then((token: String) => {
      this.form.patchValue({ recaptchaV3Token: token });
    })

    let celular = this.form.get('celularCompletoBenef').value;

    this.form.get('DDDCelularBenef').setValue(celular.slice(0,2));

    this.form.get('celularBenef').setValue(celular.slice(2));

    let prcBenef = this.form.get('prcBenef').value;


    if(prcBenef < 1 || prcBenef > 100){
      alert("O percentual deve estar entre 1 e 100");
      return false;
    }

    this.loadingInserir = true;


    this.cadastro.inserirBeneficiario(this.form.value)
    .pipe(
      finalize(() => { this.loadingInserir=false })
    )
    .subscribe(
      (res: any)=>{
        this.listar();
        this.toastr.success("Beneficiário inserido com sucesso !");

        $("#benefeciarioModal").modal('hide');
      },
      (error: HttpErrorResponse) => {
        this.toastr.error(error.error.ex);
      }
    )

    return true;
  }

  remover(){

    this.loadingRemover = true;

    this.cadastro
    .finalizarVigenciaBeneficiario(this.benefSelecionado.COD_PART_BENEF, this.assinatura)
    .pipe(
      finalize(() => { this.loadingRemover=false })
    )
    .subscribe(
      (res: any)=>{
        this.listar();
        this.toastr.success("Beneficiário excluído com sucesso !");

        $("#assinaturaModal").modal('hide');
      },
      (error: HttpErrorResponse) => {
        this.toastr.error(error.error.ex);
      }
    )

    return false;
  }

  listarParentesco(){
    this.adesao.ListarParentescoBenef()
    .subscribe(
      (res:any)=>{
        this.parentescos = res;
      }
    )
  }

}
